<template>
  <div class="youmaylike">
    <div class="comp-title">
      <div class="left">
        <h1 class="text-uppercase color-text-bold">
          <img src="../../../../static/img/comp-title.png"/>
          Có thể bạn thích
        </h1>
      </div>

      <div class="right">
        <pagination
          :total-pages="totalPage"
          :total="totalRecord"
          :per-page="10"
          :current-page="currentPage"
          @pagechanged="onPageChange"
          :previous-name="previousName"
          :next-name="nextName"
        >
          <span class="page">{{ currentPage}}/{{ totalPage }}</span>
        </pagination>
      </div>

      <div style="clear: both"></div>
    </div>

    <div class="col-container">
      <div class="item" v-for="item in dataList">
        <a :href="settings.prefixSong + item.id + '/' + convertToAlias(item.song)">
          <img :src="item.thumbnail != '' ? item.thumbnail : settings.defaultThumbnailBigSong "/>
          <h4 class="song color-text">{{ item.song }}</h4>
          <h5 class="singer color-text">{{ item.singer }}</h5>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import Pagination from '../../Pagination'
  export default {
    name: "YouMayLike",
    components: {
      "pagination": Pagination
    },
    data(){
      return{
        currentPage: 1,
        totalRecord: 1,
        totalPage: 2,
        previousName: "previousArrow",
        nextName: "nextArrow",
        dataList: []
      }
    },
    created(){
      this.getDataList();
    },
    methods: {
      getDataList(){
        var dataPost = {
          pageSize: 8,
          pageIndex: this.currentPage,
          orderBy: this.settings.orderByYouMayLike
        };
        axios.post(api.youMayLike, dataPost)
          .then(response => {
            var res = response.data;
            this.dataList = res.result;
            this.totalRecord = res.totalRecord;
            //this.totalPage = res.totalPage;
          }).catch(error => {
          console.log(error);
        });
      },
      onPageChange(page){
        this.currentPage = page;
      }
    },
    watch: {
      "currentPage": {
        handler: 'getDataList',
        immediate: true
      }
    }
  }
</script>

<style scoped>
  .col-container{
    flex-wrap: wrap;
    display: flex;
  }

  .item{
    width: calc(100% / 4);
    text-align: left;
    margin-bottom: 2rem;
  }
  .item:nth-of-type(4n) {
    margin-right: 0;
  }

  .item:nth-of-type(4n+1) {
    margin-left: 0;
  }
  .item img{
    width: 200px;
    height: 110px;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/web/YouMayLike.vue